import { ALLOWED_DOMAINS } from "../../constants"
import { createReducer, updateDeepState, updateState } from "redux/handlers"
import types from './types'

const initialState = {
  isListsAvailable: ALLOWED_DOMAINS.isOP || false,
  listsWithUsers: 0,
  isVisible: false,
  isRequestsInProgress: false,
  lists: [],
  collapse: [],
  removeFromLists: 0,
  poolListOrder: [],
  withLists: true
}

const listsWithUsers = (state, action) => {
  return updateDeepState(state, {
    listsWithUsers: action.listsWithUsers,
    withLists: true,
    isListsAvailable: action.withLists,
    removeFromLists: state.removeFromLists + 1
  })
}

const listsAndUsers = (state, action) => {
  return updateState(state, {
    lists: action.lists,
    listsWithUsers: action.listsWithUsers,
    withLists: true,
    isListsAvailable: action.withLists,
    poolListOrder: action.poolListOrder,
    removeFromLists: state.removeFromLists + 1
  })
}

const collapse = (state, action) => {
  return updateState(state, { collapse: action.collapse })
}

const incrementRemoveFromList = (state, action) => {
  return updateState(state, { removeFromLists: state.removeFromLists + 1 })
}

const updateListOrder = (state, action) => {
  return updateState(state, { poolListOrder: action.poolListOrder })
}

const updateIsListAvailable = (state, action) => {
  return updateState(state, {
    isListsAvailable: action.isListsAvailable,
    withLists: action.isListsAvailable
  })
}

export default createReducer(initialState, {
  [types.LISTS_WITH_USERS]: listsWithUsers,
  [types.LISTS_AND_USERS]: listsAndUsers,
  [types.COLLAPSE]: collapse,
  [types.INCREMENT_REMOVE_FROM_LIST]: incrementRemoveFromList,
  [types.UPDATE_LIST_ORDER]: updateListOrder,
  [types.UPDATE_IS_LIST_AVAILABLE]: updateIsListAvailable
})
